import dayjs from 'dayjs';

const tabs = {
  roulette: ['rla'],
  nuevo: [
    'vs5luckydogly',
    'vswayslions',
    'vs10fortnhsly',
    'vs9ridelightng',
    // 'vs20fatbook',
    // 'vs20dhsuper',
    // 'vs5luckydogly',
    // 'vsways5lionsr',
    // 'vs10fortnhsly',
    // 'vs9ridelightng',
    //
    // 'vs10fortnpig',
    // 'vswaysmodfr',
    // 'vswayssavlgnd',
    // 'vs12bgrbspl',
    // 'vs10fireice',
    // 'vswaysaztec',
  ],
  popular: ['vs5joker', 'vs5jokerdice', 'vs25goldparty', 'vswaysbufking', 'vs432congocash'],
  xMas: [
    'vs20sbxmas',
    'vs10bxmasbnza',
    'vs12bbbxmas',
    'vs10bbsplxmas',
    'vs20sugrux',
    'vs20schristmas',
    'vs20porbs',
    'vs20xmascarol',
    'vs10bbxext',
    'vs25xmasparty',
    'vs20santawonder',
    'vs20santa',
    'vs10ddcbells',
    'vs20leprexmas',
  ],
  halloween: [
    'vs10bhallbnza3', // Big Bass Halloween 3 (vs10bhallbnza3) - Pragmatic
    'vswayspompmr2', // Zombie School Megaways - Pragmatic
    'vs25wolfgold', // Wolf Gold (vs25wolfgold) - Pragmatic
    'vswayswildbrst', // Witch Heart Megaways (vswayswildbrst)
    'vs20fatbook', // Book of Monsters (vs20fatbook)
    'vs10fangfree', // Fangtastic Freespins (vs10fangfree)
    'vs10bhallbnza2', // Big Bass Halloween 2 (vs10bhallbnza2)
    'vswayswbounty', // Vampy Party (vswayswbounty)
    'vs20mergedwndw', // Blade & Fangs (vs20mergedwndw)
    'vs10bhallbnza', // Big Bass Halloween (vs10bhallbnza)
    'vs40infwild', // Infective Wild (vs40infwild)
    'vs243nudge4gold', // Hellvis Wild™ (vs243nudge4gold)
    'vs20daydead', // Day of Dead™ (vs20daydead)
    'vs20magicpot', // The Magic Cauldron – Enchanted Brew (vs20magicpot)
    'vswaysmadame', // Madame Destiny Megaways™ (vswaysmadame)
    'vs40voodoo', // Voodoo Magic (vs40voodoo)
    'vs25walker', // Wild Walker (vs25walker)
    'vswayswerewolf', // Curse of the Werewolf Megaways™ (vswayswerewolf)
    'vs4096mystery', // Mysterious (vs4096mystery)
    'vs10vampwolf', // Vampires vs Wolves (vs10vampwolf)
    'vs10madame', // Madame Destiny (vs10madame)
  ],
};

const fatPandaGamesIds = [
  'vs10emotiwins',
  'vs5jellyc',
  'vs5luckydogly',
  'vs10forwildly',
  'vs10fortnhsly',
  'vs5luckytigly',
];

function getTab(slotName, isNew) {
  const trueTab = Object.keys(tabs).reduce(
    (acc, tab) => (tabs[tab].findIndex(item => item === slotName) === -1 ? acc : [...acc, tab]),
    ['slotMachines'],
  );

  if (isNew) {
    trueTab.push('nuevo');
  }

  return trueTab;
}

export { getTab, fatPandaGamesIds };
